export const resourcesMainQueryKey = "resources";
